define([
	"dojo/_base/declare",
	"csi",
	"csi/session",
	"csi/state",
	"csi/xml"
], function(declare,csi,session,state,xml) {

	return declare(null, {
		// String: product alternative URL to use to filter list of PartMaterials to display
		activeProductAlternative: csi.EMPTY_URL,

		postMixInProperties: function() {
			// summary: determine if active product alternative is specified in browser location (such as when print from DataPackage)
			if (state.get("print") && !state.get("printAdHoc")) {
				var url = session.getLocationValue("BOMAlternative");

				if (xml.isValidURL(url)) {
					this.activeProductAlternative = url;
				}
			}

			this.inherited(arguments);
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.activeProductAlternative = this.activeProductAlternative;
			return params;
		},

		onChangeCustomView: function() {
			// summary: reset active product colors when custom view is changed
			this.set("activeProductAlternative", csi.EMPTY_URL);
			this.inherited(arguments);
		},

		_addProductAlternativeQuery: function(/*Query*/q) {
			// summary: add filter if specified in page location
			if (xml.isValidURL(this.activeProductAlternative)) {
				// filter out PartMaterials which are only for the selected ProductAlternative
		    	q.Or()
					.RefAttr("OnlyForProductAlternatives", xml.OP_EQUALS, this.activeProductAlternative)
            		.RefAttr("OnlyForProductAlternatives", xml.OP_NULL);
			}
		}
	});
});
